export type VoiceToolActivity = 'researching' | 'searching' | 'working';

/** Tool activity is independent of microphone capture and assistant playback. */
export function getVoiceToolActivity(
  tools: readonly string[]
): VoiceToolActivity | null {
  if (tools.includes('quick_research')) return 'researching';
  if (tools.includes('web_search')) return 'searching';
  return tools.some((name) => name.trim().length > 0) ? 'working' : null;
}
